const reAndroid = /Android|webOS/i;
const reIOS = /iPad|iPhone|iPod|Opera Mini/i;

const ua = navigator.userAgent || navigator.vendor || window.opera;

export const isAndroid = (userAgent = ua) => reAndroid.test(userAgent);
export const isIOS = (userAgent = ua) => reIOS.test(userAgent);
export const isMobile = (userAgent = ua) => isAndroid(userAgent) || isIOS(userAgent);
